import EventsService from "@/services/Events.js";


const state = {
    album: {
        event_id: '',
        files: []
    }
};


const actions = {
    clearAlbum: function (store) {
        store.commit('CLEAR')
    },
    loadAlbum: function (store, event_id = '') {
        EventsService.loadAlbum(event_id).then((response) => {
            store.commit('SET_ALBUM', { event_id: event_id, files: response.data })
        })
    },
    async saveAlbum(store, obj) {
        return await EventsService.saveAlbum(obj);
    }
}
const mutations = {
    CLEAR: state => {
        state.album = {
            event_id: '',
            files: []
        };
    },
    SET_ALBUM: (state, obj = { event_id: '', files: [] }) => {
        state.album = obj;
    }
}

const getters = {
    get_album: state => {
        return { ...state.album };
    },
}



export default {
    state,
    mutations,
    getters,
    actions
};
